// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"362":"1016d4de","726":"4b5888ee"}[chunkId] + ".chunk.js";
};